/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Business } from './Business';
import {
    BusinessFromJSON,
    BusinessFromJSONTyped,
    BusinessToJSON,
    BusinessToJSONTyped,
} from './Business';

/**
 * 
 * @export
 * @interface UpdateBulkBusinessEnableBody
 */
export interface UpdateBulkBusinessEnableBody {
    /**
     * 
     * @type {Array<Business>}
     * @memberof UpdateBulkBusinessEnableBody
     */
    businesses: Array<Business>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBulkBusinessEnableBody
     */
    isEnabled: boolean;
}

/**
 * Check if a given object implements the UpdateBulkBusinessEnableBody interface.
 */
export function instanceOfUpdateBulkBusinessEnableBody(value: object): value is UpdateBulkBusinessEnableBody {
    if (!('businesses' in value) || value['businesses'] === undefined) return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined) return false;
    return true;
}

export function UpdateBulkBusinessEnableBodyFromJSON(json: any): UpdateBulkBusinessEnableBody {
    return UpdateBulkBusinessEnableBodyFromJSONTyped(json, false);
}

export function UpdateBulkBusinessEnableBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBulkBusinessEnableBody {
    if (json == null) {
        return json;
    }
    return {
        
        'businesses': ((json['businesses'] as Array<any>).map(BusinessFromJSON)),
        'isEnabled': json['isEnabled'],
    };
}

export function UpdateBulkBusinessEnableBodyToJSON(json: any): UpdateBulkBusinessEnableBody {
    return UpdateBulkBusinessEnableBodyToJSONTyped(json, false);
}

export function UpdateBulkBusinessEnableBodyToJSONTyped(value?: UpdateBulkBusinessEnableBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businesses': ((value['businesses'] as Array<any>).map(BusinessToJSON)),
        'isEnabled': value['isEnabled'],
    };
}

